import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What does Evermark provide to specifying engineers?",
  answer: "Evermark Industrial Solutions provides CSI 3-part specification language, material data sheets, standards references, basis-of-design language, submittal templates, and physical sample kits for nameplate, legend plate, and arc flash label identification."
}, {
  question: "Can I name Evermark as the basis of design?",
  answer: "Yes — Evermark Industrial Solutions supplies basis-of-design language and CSI 3-part spec text written to be adapted into a project manual's identification section, while the engineer defines approved-equal criteria."
}, {
  question: "Does Evermark perform arc flash or engineering studies?",
  answer: "No — Evermark Industrial Solutions does not perform arc flash, short-circuit, or coordination studies and is not the engineer of record; it produces marking from data the engineer or owner provides and supplies supporting documentation."
}, {
  question: "Which standards does Evermark's documentation reference?",
  answer: "Evermark Industrial Solutions maps its products to standards including UL 508A, NFPA 70E, NEC 110.16, ANSI Z535, and MIL-SPEC; the applicable standard and edition for a project are determined by the engineer of record."
}, {
  question: "How do I get the spec language and data sheets?",
  answer: "Request a submittal package from Evermark Industrial Solutions and the CSI language, material data sheets, and standards references are sent for your spec section — see {{verify: submittal package delivery details}}."
}];
export default function Faq() {
  return <section id="faq" className="bg-muted/30 py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground tracking-tight">
            Specifying Industrial Identification — Common Questions
          </h2>
        </div>

        <div className="bg-background rounded-lg shadow-sm border border-border p-4 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold font-default text-foreground hover:text-primary transition-colors py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}